import TtsAnnounce from "./TtsAnnounce";
import FileAnnounce from "./FileAnnounce";
import Hangup from "./HangupNode";
import Record from "./Record";
import AnswerNode from "./AnswerNode";
import ListRouting from "./ListRoutingNode";
import CallStatusRouting from "./CallStatusRoutingNode";
import MarkAsAnswered from "./MarkAsAnsweredNode";
import SmartGreeting from "./SmartGreetingNode";
import SendWhatsapp from "./SendWhatsappNode";
import AddLabel from "./AddLabelNode";
import TimeSwitchNode from "./TimeSwitchNode";
import DialNode from "./DialNode";
import IVRNode from "./IVRNode";
import Webhook from "./Webhook";
import WebhookRoutingNode from "./WebhookRoutingNode";
import OpeningTimeNode from "./OpeningTimeNode";
import DialplanRedirect from "./DialplanRedirectNode";
import Agent, {AgentIntrospection} from "./AgentNode";

export const NODES = {
    "ANSWER": AnswerNode,
    "TTS_ANNOUNCE": TtsAnnounce,
    "FILE_ANNOUNCE": FileAnnounce,
    "HANGUP": Hangup,
    "RECORD": Record,
    "LIST_ROUTING": ListRouting,
    "CALL_STATUS_ROUTING": CallStatusRouting,
    "MARK_AS_ANSWERED": MarkAsAnswered,
    "SMART_GREETING": SmartGreeting,
    "SEND_WHATSAPP": SendWhatsapp,
    "ADD_LABEL": AddLabel,
    "DIALPLAN_REDIRECT": DialplanRedirect,
    "TIME_SWITCH": TimeSwitchNode,
    "DIAL": DialNode,

    "OPENING_TIME": OpeningTimeNode,
    "IVR": IVRNode,
    "WEBHOOK": Webhook,
    "WEBHOOK_ROUTING": WebhookRoutingNode,
    "AGENT": Agent,
    "AGENT_INTROSPECTION": AgentIntrospection,
}
